/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable unicorn/prefer-node-protocol */

// eslint-disable-next-line unicorn/prefer-node-protocol


export function isVideoOrImage(extension: string): 'img' | 'video' | 'none' {
  const videoExtensions = [
    '.mp4',
    '.avi',
    '.mov',
    '.mkv',
    '.wmv',
    '.flv',
    '.webm',
  ];
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];

  const lowerCaseExtension = extension?.toLowerCase();

  if (videoExtensions.includes(lowerCaseExtension)) {
    return 'video'; // It's a video extension
  }

  if (imageExtensions.includes(lowerCaseExtension)) {
    return 'img'; // It's an image extension
  }

  return 'none'; // It's neither a video nor an image extension
}

export function validateEmail(email: string): boolean {
  // Regular expression for validating email addresses
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Test the email against the regular expression
  return emailRegex.test(email);
}

export function replaceAll(
  input: string,
  search: string,
  replacement: string,
): string {
  // Escape special characters in the search string
  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a regular expression with the global flag to match all occurrences
  const regex = new RegExp(escapedSearch, 'g');

  // Use the replace method to replace all occurrences
  return input.replace(regex, replacement);
}


export const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', options);
};


export interface RssItem {
  title: string
  url: string
  date: string
  guid: string
}

  // Function to escape XML special characters
  export function escapeXML(str: string): string {
    return str.replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&apos;');
  }
  
  // Function to sanitize XML by removing invalid control characters
  export function sanitizeXML(str: string): string {
    // eslint-disable-next-line no-control-regex
    return str.replace(/[\x00-\x1F]/g, ''); // Remove control characters
  }

// export function generateTechnicalPressRss(posts: RssItem[], siteUrl: string) {
//   const rss = `<?xml version="1.0" encoding="UTF-8"?>
// <rss version="2.0" xmlns:atom="http://www.w3.org/2005/Atom">
//   <channel>
//     <title>Sahil CNC Technical Press</title>
//     <link>${siteUrl}/technical-press-news</link>
//     <description>Latest technical press updates from Sahil CNC</description>
//     <language>en-us</language>
//     <lastBuildDate>${new Date().toUTCString()}</lastBuildDate>
//     <atom:link href="${siteUrl}/technical-press-rss.xml" rel="self" type="application/rss+xml"/>
//     ${posts.map(post => `
//       <item>
//         <title>${escapeXML(post.title)}</title>
//         <link>${post.url}</link>
//         <guid>${post.guid}</guid>
//         <pubDate>${new Date(post.date).toUTCString()}</pubDate>
//       </item>
//     `).join('')}
//   </channel>
// </rss>`

//   writeFileSync(join(__dirname, 'public/technical-press-rss.xml'), rss)
// }
